import { useState } from "react";
import "./MemberTier.css";
import ArrowRight from "../../assets/icons/ArrowRight.svg";
import { Link } from "react-router-dom";
import ProfileLayout from "../../components/profilelayout/ProfileLayout";
import FallbackImg from "../../components/FallbackImg";

const MemberTier = () => {
  const [activeTab, setActiveTab] = useState("platinum");

  return (
    <ProfileLayout>
      <div className="membertier">
        <div className="membertier-content">
          <div className="membertier-title-container">
            <Link to="/myloyalty" className="mtback-button">
              <FallbackImg
                src={ArrowRight}
                alt="arrowright"
                width="20"
                height="20"
                style={{ display: "flex" }}
              />
            </Link>
            <div className="membertier-title">
              <strong>MEMBER TIER</strong>
            </div>
          </div>

          <div className="membertier-main">
            <div
              className={`normal${activeTab === "normal" ? " active-tab" : ""}`}
              onClick={() => setActiveTab("normal")}
            >
              Normal Member
            </div>
            <div
              className={`silver${activeTab === "silver" ? " active-tab" : ""}`}
              onClick={() => setActiveTab("silver")}
            >
              Silver
            </div>
            <div
              className={`gold${activeTab === "gold" ? " active-tab" : ""}`}
              onClick={() => setActiveTab("gold")}
            >
              Gold
            </div>
            <div
              className={`platinum${
                activeTab === "platinum" ? " active-tab" : ""
              }`}
              onClick={() => setActiveTab("platinum")}
            >
              Platinum
            </div>
          </div>

          <div className="membertier-line"></div>

          {activeTab === "platinum" && (
            <div className="membertier-item">
              <div className="membertier-name">
                <strong>Exclusive Discounts</strong>
              </div>
              <div className="membertier-descrip">
                Enjoy up to 20% off on selected products or services
              </div>
            </div>
          )}
        </div>
      </div>
    </ProfileLayout>
  );
};

export default MemberTier;
